// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1c5fA","content":"ManualTimeModal_content__2tuqB"};